import React from 'react'
import './Naslov.css'

const naslov = (props) => {
  return (
    <header aria-label="Naslov">
      <div className="container">
        <div className="naslov-text">
          <h3>{props.naslov}</h3>
        </div>
      </div>
    </header>
  )
}

export default naslov
